export default __webpack_public_path__ + "static/media/Graphics_business-card-fornt-min.9464194a.jpg";